var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 22,
    viewBox: "0 0 13 22",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.189 11.717h2.63v9.928c0 .196.174.355.387.355h4.461c.214 0 .387-.159.387-.355v-9.881h3.024c.197 0 .363-.135.385-.314l.46-3.655a.336.336 0 00-.096-.277.403.403 0 00-.289-.119H9.054V5.11c0-.691.406-1.042 1.207-1.042h2.277c.214 0 .387-.159.387-.355V.357c0-.196-.173-.354-.387-.354H9.4A3.117 3.117 0 009.255 0c-.544 0-2.437.098-3.933 1.359-1.657 1.398-1.426 3.07-1.371 3.36V7.4H1.189c-.214 0-.387.159-.387.355v3.608c0 .196.173.355.387.355z"
  })));
}
export default SvgFacebook;